import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';

export const TUTORIAL_SEEN_KEY = 'seu.video.telaEmBranco.tutorialSeen.v1';
const VIDEO_SRC = `${process.env.PUBLIC_URL || ''}/tela-em-branco-tutorial.mp4`;

export function tutorialSeen(): boolean {
  try {
    return localStorage.getItem(TUTORIAL_SEEN_KEY) === '1';
  } catch {
    return true;
  }
}

export function markTutorialSeen(): void {
  try {
    localStorage.setItem(TUTORIAL_SEEN_KEY, '1');
  } catch {
    /* storage unavailable */
  }
}

type Props = {
  open: boolean;
  onClose: () => void;
};

export default function CanvasTutorialModal({ open, onClose }: Props) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    const v = videoRef.current;
    if (v) {
      v.currentTime = 0;
      void v.play().catch(() => {});
    }
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="tb-tutorial-overlay" onPointerDown={(e) => e.stopPropagation()} onClick={onClose}>
      <div
        className="tb-tutorial-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="tb-tutorial-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="tb-tutorial-close" aria-label="Fechar" onClick={onClose}>
          <X size={18} />
        </button>
        <div className="tb-tutorial-head">
          <span className="tb-tutorial-badge">Novo</span>
          <h2 id="tb-tutorial-title" className="tb-tutorial-title">Conheça a Tela em branco</h2>
          <p className="tb-tutorial-sub">
            Solte suas fotos, ligue as setas e peça pelo chat. O agente monta o roteiro, as cenas e o vídeo.
          </p>
        </div>
        <div className="tb-tutorial-video">
          <video ref={videoRef} src={VIDEO_SRC} autoPlay muted playsInline loop preload="auto" />
        </div>
        <div className="tb-tutorial-actions">
          <button type="button" className="tb-tutorial-primary" onClick={onClose}>
            Começar agora
          </button>
        </div>
      </div>
    </div>
  );
}
